export interface ApiResponseItem {
  event_id?: string;
  college_id: number;
  college_name_display: string;
  event_category_name: string;
  start_date: string; // "YYYY-MM-DD"
  open_day_qualification: string;
  venue: string;
  postcode: string;
  start_time: string;
  end_time: string;
  wusca_overall_rating: number;
  wusca_overall_ranking: number;
  open_day_count: number;
  book_openday_form: string;
  order_item_id: string | null;
  suborder_item_id: string | null;
  college_logo: string;
  od_more_flag: string;
  booking_url: string;
  college_hero_image: string;
  advertiser_type?: string;
  is_sponsored?:boolean;
  veppleFlag?:string;
}

export interface CardData {
  isSponsored?:boolean;
  advertiserType?: string,
  image: string;
  logo: string;
  institutionId: number;
  institutionName: string;
  institutionTextKey: string;
  eventType: string;
  eventId?:any;
  eventDate: { month: string; date: string; year: string };
  openDaysType: string;
  campusAddress: string;
  eventTime: string;
  wuscaDetails: Array<{ rating: number; wuscaRanking: string }>;
  courseCount: number;
  bookingUrl: string;
  ctaDetails: {
    openDayFlag: string;
    orderItemId: string;
    subOrderItemId: string;
  };
  veppleFlag?:string;
}

const MONTH_ABBREVIATIONS = [
  "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
  "JUL", "AUG", "SEP", "OCT", "NOV", "DEC",
];

export function getOrdinalSuffix(n: number): string {
  const mod100 = n % 100;
  if (mod100 === 11 || mod100 === 12 || mod100 === 13) {
    return `${n}th`;
  }
  const mod10 = n % 10;
  if (mod10 === 1) return `${n}st`;
  if (mod10 === 2) return `${n}nd`;
  if (mod10 === 3) return `${n}rd`;
  return `${n}th`;
}

export function transformOpenDayItem(item: ApiResponseItem): CardData {
  const [year, month, day] = (item?.start_date ?? "").split("-");
  const monthIndex = parseInt(month ?? "0", 10) - 1;

  return {
    isSponsored: item?.is_sponsored ?? false,
    advertiserType: item?.advertiser_type,
    image: item?.college_hero_image,
    logo: item?.college_logo ?? "",
    institutionId: item?.college_id ?? 0,
    institutionName: item?.college_name_display ?? "",
    institutionTextKey: (item?.college_name_display ?? "").toLowerCase().replace(/ /g, "-"),
    eventType: item?.event_category_name ?? "",
    eventId:item?.event_id ?? "",
    bookingUrl: item?.booking_url,
    eventDate: {
      month: MONTH_ABBREVIATIONS[monthIndex] ?? "",
      date: String(parseInt(day ?? "0", 10)),
      year: year ?? "",
    },
    openDaysType: item?.open_day_qualification ?? "",
    campusAddress: `${item?.venue ?? ""}, ${item?.postcode ?? ""}`,
    eventTime: `${item?.start_time ?? ""}-${item?.end_time ?? ""}`,
    wuscaDetails: [
      {
        rating: item?.wusca_overall_rating ?? 0,
        wuscaRanking: getOrdinalSuffix(item?.wusca_overall_ranking ?? 0),
      },
    ],
    courseCount: item?.open_day_count ?? 0,
    ctaDetails: {
      openDayFlag: item?.od_more_flag ?? "",
      orderItemId: item?.order_item_id ?? "",
      subOrderItemId: item?.suborder_item_id ?? "",
    },
  };
}
